import { IState } from '../../store';

export const selectShouldRenderContacts = (state: IState) => {
  const kp = state.offerData.kp;

  // Если обяъвление загородки привязано к коттеджному поселку,
  // проверяем возможность отображения телефонов у застройщика.
  return kp ? kp.displayBuilderPhone : true;
};
